module.exports = __webpack_public_path__ + "img/1534086917.cd2e3bd7.jpg";